import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import Motion from '@/app/components/Motion';
import RichText from '@/app/components/RichText';

const Hero = () => {
  const t = useTranslations();

  return (
    <section
      className="pb-16 md:flex md:flex-col md:justify-between"
      data-cy="leadership_hero"
    >
      <LayoutGrid className="gap-y-2 md:gap-y-5">
        <GridItem
          colEnd={{ sm: 'main', md: 20, lg: 20, xl: 16 }}
          colStart={{ sm: 'main', md: 6, lg: 5 }}
        >
          <Motion
            initial={{ opacity: 0, y: 100 }}
            viewport={{ once: true }}
            transition={{ duration: 0.75, type: 'tween' }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            <TypographyV3
              Element="h1"
              variant="h1"
              color="dark"
              className="break-words hyphens-none"
            >
              {t('leadership_hero_heading')}
            </TypographyV3>
          </Motion>
        </GridItem>
        <GridItem
          colEnd={{ sm: 'main', md: 22, lg: 20, xl: 19 }}
          colStart={{ sm: 'main', md: 10, lg: 9 }}
          rowStart={{ sm: 2 }}
        >
          <Motion
            initial={{ opacity: 0, y: 100 }}
            viewport={{ once: true }}
            transition={{ delay: 0.15, duration: 0.75, type: 'tween' }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            <TypographyV3 variant="h6" color="dark">
              <RichText messageKey="leadership_hero_copy" />
            </TypographyV3>
          </Motion>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default Hero;
